import RequestAbstract from "../abstract";

export default class TwoFactorTotp extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "challenge/totp";
    }

    async check(code) {
        const result = await this.authPostForm(this.link, { code });
        this.updateLocalStorageUser(result);
        return result;
    }

}
